import { render, staticRenderFns } from "./DetailsReceptions.vue?vue&type=template&id=9ad1942a&scoped=true&lang=pug&"
import script from "./DetailsReceptions.vue?vue&type=script&lang=js&"
export * from "./DetailsReceptions.vue?vue&type=script&lang=js&"
import style0 from "./DetailsReceptions.vue?vue&type=style&index=0&id=9ad1942a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad1942a",
  null
  
)

export default component.exports